function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import { DEBIT_NOTE, INVOICE, MIN_NOTE_AMOUNT } from './apply.credit.note.modal.constants';
import { constraintErrorMessages } from 'invision-core/src/utilities/angular.form.utilities';
import { CurrentBusinessUnitCurrencyCodeSelector } from 'invision-core/src/components/session/businessunit.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { applyCreditNote, retrieveInvoicesForDropdown } from '../../../reducers/actions/customer.billing.actions';
import * as BillingPaymentsConstants from '../billing.payments.constants';
import { InvoiceListForDropDownSelector, IsApplyingCreditNoteSelector, IsFetchingInvoiceListSelector } from '../../../reducers/selectors/customer.billing.selectors';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import LocaleKeys from '../../../locales/keys';
import moment from 'moment';
var ApplyCreditNoteModalController = /*#__PURE__*/function () {
  function ApplyCreditNoteModalController($ngRedux, $filter, uiNotificationService) {
    _classCallCheck(this, ApplyCreditNoteModalController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      formattedInvoiceAndDebitNoteList: [],
      localeKeys: LocaleKeys,
      MIN_NOTE_AMOUNT: MIN_NOTE_AMOUNT,
      selectedInvoiceOrDebitNote: null,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ApplyCreditNoteModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          invoiceAndDebitNoteList: InvoiceListForDropDownSelector(store),
          isApplyingCreditNote: IsApplyingCreditNoteSelector(store),
          isFetchingInvoiceAndDebitNoteList: IsFetchingInvoiceListSelector(store)
        };
      };
      var controllerActions = {
        applyCreditNote: applyCreditNote,
        retrieveInvoicesForDropdown: retrieveInvoicesForDropdown
      };
      this.modalTitle = "".concat(i18n.translate(this.localeKeys.CREDIT_DEBIT_NOTE.APPLY_CREDIT_NOTE_TITLE)).concat(this.creditNoteData.referenceId);
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.currencyCode = this.creditNoteData.currencyCode || this.state.currentBusinessUnitCurrencyCode;
      this.getInvoiceAndDebitNotesList();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "getInvoiceAndDebitNotesList",
    value: function getInvoiceAndDebitNotesList() {
      var _this2 = this;
      var getInvoiceAndDebitNotesListRequest = {
        customerId: this.state.currentCustomerId,
        request: {
          Filter: BillingPaymentsConstants.INVOICES | BillingPaymentsConstants.DEBIT_NOTES
        }
      };
      this.actions.retrieveInvoicesForDropdown(getInvoiceAndDebitNotesListRequest).then(function () {
        _this2.formatInvoiceAndDebitNotesList();
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.onClose();
    }
  }, {
    key: "formatInvoiceAndDebitNotesList",
    value: function formatInvoiceAndDebitNotesList() {
      var _this3 = this;
      var clonedInvoiceAndDebitNoteList = clone(this.state.invoiceAndDebitNoteList);
      clonedInvoiceAndDebitNoteList.forEach(function (item) {
        if (item.Invoice && item.Invoice.CurrentDue > 0) {
          _this3.formattedInvoiceAndDebitNoteList.push({
            amount: item.Invoice.CurrentDue,
            id: item.Invoice.InvoiceId,
            text: "".concat(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.INVOICE_PREFIX)).concat(item.Invoice.InvoiceNumber, " - ").concat(_this3.$filter('invCurrency')(item.Invoice.CurrentDue, item.Invoice.CurrencyCode)),
            type: INVOICE
          });
        }
        if (item.DebitNote && item.DebitNote.RemainingBalance > 0) {
          _this3.formattedInvoiceAndDebitNoteList.push({
            amount: item.DebitNote.RemainingBalance,
            id: item.DebitNote.Id,
            text: "".concat(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.DEBIT_NOTE_PREFIX)).concat(item.DebitNote.ReferenceId, " - ").concat(_this3.$filter('invCurrency')(item.DebitNote.RemainingBalance, item.DebitNote.CurrencyCode)),
            type: DEBIT_NOTE
          });
        }
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var creditNoteBalance = Math.abs(this.creditNoteData.remainingBalance);
      this.showMaxNoteAmountError = false;
      this.maxNoteAmount = this.selectedInvoiceOrDebitNote && this.selectedInvoiceOrDebitNote.amount ? Math.min(this.selectedInvoiceOrDebitNote.amount, creditNoteBalance) : creditNoteBalance;
      this.formErrorMessages = constraintErrorMessages(undefined, this.applyNoteForm, {
        noteAmount: LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_TO_APPLY,
        selectedInvoiceOrDebitNote: LocaleKeys.CREDIT_DEBIT_NOTE.INVOICE_DEBIT_NOTE
      }, {
        min: {
          noteAmount: this.$filter('invCurrency')(this.MIN_NOTE_AMOUNT, this.currencyCode)
        }
      });
      if (this.noteAmount > this.maxNoteAmount) {
        this.showMaxNoteAmountError = true;
        var message = '';
        if (!this.selectedInvoiceOrDebitNote) {
          message = i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_TO_APPLY_EXCEEDS_BALANCE_ERROR);
        } else if (this.selectedInvoiceOrDebitNote) {
          if (this.selectedInvoiceOrDebitNote.amount === creditNoteBalance || this.noteAmount > this.selectedInvoiceOrDebitNote.amount && this.noteAmount > creditNoteBalance) {
            message = i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_TO_APPLY_MAX_ERROR_SUMMARY);
          } else if (this.maxNoteAmount === this.selectedInvoiceOrDebitNote.amount) {
            if (this.noteAmount < this.selectedInvoiceOrDebitNote.amount) {
              message = i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_TO_APPLY_EXCEEDS_BALANCE_ERROR);
            } else {
              message = i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_TO_APPLY_EXCEEDS_AMOUNT_DUE_ERROR);
            }
          } else if (this.maxNoteAmount === creditNoteBalance) {
            if (this.noteAmount < creditNoteBalance) {
              message = i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_TO_APPLY_EXCEEDS_AMOUNT_DUE_ERROR);
            } else {
              message = i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_TO_APPLY_EXCEEDS_BALANCE_ERROR);
            }
          }
        }
        if (message) {
          this.formErrorMessages.push("".concat(message, " (").concat(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.MAX_AMOUNT)).concat(this.maxNoteAmount, ")"));
        }
      }
    }
  }, {
    key: "applyNote",
    value: function applyNote() {
      var _this4 = this;
      if (this.applyNoteForm.$valid && !this.showMaxNoteAmountError) {
        var request = {
          customerId: this.state.currentCustomerId,
          request: {
            AmountToApply: parseFloat(this.noteAmount).toFixed(2),
            CreditNoteId: this.creditNoteData.creditNoteId,
            DebitNoteId: this.selectedInvoiceOrDebitNote && this.selectedInvoiceOrDebitNote.type === DEBIT_NOTE ? this.selectedInvoiceOrDebitNote.id : null,
            InvoiceId: this.selectedInvoiceOrDebitNote && this.selectedInvoiceOrDebitNote.type === INVOICE ? this.selectedInvoiceOrDebitNote.id : null
          }
        };
        this.actions.applyCreditNote(request).then(function () {
          _this4.uiNotificationService.transientSuccess(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.CREDIT_NOTE_APPLIED));
          if (_this4.formErrorMessages) {
            _this4.formErrorMessages.length = 0;
          }
          _this4.onSuccess();
        }).catch(function (error) {
          if (_this4.formErrorMessages) {
            _this4.formErrorMessages.length = 0;
          }
          _this4.formErrorMessages.push(error.translatedMessage);
        });
      } else {
        this.validateForm();
      }
    }
  }]);
}();
export default {
  controller: ApplyCreditNoteModalController,
  controllerAs: 'ApplyCreditNoteModalController',
  template: require('./apply.credit.note.modal.html'),
  bindings: {
    config: '<',
    creditNoteData: '<?',
    onClose: '&',
    onSuccess: '&'
  }
};